import "./index.scss";
import { debounce } from "../../helpers";

export const accordion = (
  ElClassName: string,
  CollapseRegion: string,
  Heading: string,
  ClickableBlock?: boolean,
  ifDebounce: boolean = true
) => {
  const wrapper: HTMLElement | null = document.querySelector(ElClassName);

  var accordianHeaders = Array.from(
    document.querySelectorAll(ElClassName)
  ).filter((el: HTMLElement) => {
    const region: HTMLElement | null = el.querySelector(CollapseRegion);
    return region !== null;
  });

  var resetNav = function(_headers?: any) {
    var headers = _headers || [...accordianHeaders];
    const region: HTMLElement | null = document.querySelector(CollapseRegion);

    headers.forEach((h: any) => {
      const heading: HTMLElement | null = h.querySelector(Heading);
      h.removeAttribute("active");
      h.classList.add("isInactive");
      h.classList.remove("isActive");
      if (heading !== null && region !== null) {
        h.style.height = `${heading.offsetHeight}px`;
      }
    });
  };

  function create() {
    if (wrapper !== null && wrapper.parentElement !== null) {
      wrapper.parentElement.classList.add("accordion-wrapper");
    }

    accordianHeaders.forEach((el: HTMLElement) => {
      const region: HTMLElement | null = el.querySelector(CollapseRegion);
      const heading: HTMLElement | null = el.querySelector(Heading);
      const icon: HTMLElement | null = el.querySelector(".icon");

      el.classList.add("isInactive");

      if (region !== null && el !== null && heading !== null) {
        const chevron = document.createElement("span");
        chevron.classList.add("icon");

        if (icon === null) {
          heading.appendChild(chevron);
        }

        if (
          ClickableBlock &&
          !heading.classList.contains("clickable-heading")
        ) {
          if (
            heading.nodeName !== "A" ||
            (heading.nodeName === "A" && heading.getAttribute("href") === "#")
          ) {
            heading.onclick = handleClick.bind(el);
            heading.classList.add("clickable-heading");
          } else {
            chevron.onclick = handleClick.bind(el);
          }
        } else {
          chevron.onclick = handleClick.bind(el);
        }

        region.classList.add("accordion-region");

        el.style.height = `${heading.offsetHeight}px`;
      }
    });

    resetNav();

    if (ifDebounce) {
      debounce({ func: () => resetNav() });
    }

    collapseHeaders.forEach((el: HTMLElement) => {
      el.addEventListener("click", resetNav, true);
    });
  }

  function handleClick(this: HTMLElement, e: Event) {
    e.preventDefault();

    var key = accordianHeaders.indexOf(this);
    var headers = [...accordianHeaders];
    const heading: HTMLElement | null = this.querySelector(Heading);
    const region: HTMLElement | null = this.querySelector(CollapseRegion);

    headers.splice(key, 1);
    resetNav(headers);

    var isActive = this.getAttribute("active");

    if (isActive == "false" || !isActive) {
      this.setAttribute("active", "true");
      this.classList.add("isActive");
      this.classList.remove("isInactive");
      if (region !== null && heading !== null) {
        this.style.height = `${region.offsetHeight + this.offsetHeight}px`;
      }
    } else {
      this.removeAttribute("active");
      this.classList.remove("isActive");
      this.classList.add("isInactive");
      if (heading !== null) {
        this.style.height = `${heading.offsetHeight}px`;
      }
    }
  }

  var collapseHeaders = Array.from(
    document.querySelectorAll(ElClassName)
  ).filter((el: HTMLElement) => {
    const region: HTMLElement | null = el.querySelector(CollapseRegion);
    return region == null;
  });

  function undo() {
    if (
      accordianHeaders !== null &&
      wrapper !== null &&
      wrapper.parentElement !== null &&
      wrapper.parentElement.classList.contains("accordion-wrapper")
    ) {
      wrapper.parentElement.classList.remove("accordion-wrapper");

      accordianHeaders.forEach((item: any) => {
        const subNav = item.querySelector(".sub-nav");
        const clickableHeading = item.querySelector(".clickable-heading");
        const heading: HTMLElement | null = item.querySelector(Heading);

        item.removeAttribute("style");
        item.classList.remove("isInactive", "clickable-heading");

        if (heading !== null) {
          heading.onclick = () => {};
        }

        if (subNav !== null) {
          subNav.classList.remove("accordion-region");
        }

        if (clickableHeading !== null) {
          clickableHeading.classList.remove("clickable-heading");
        }
      });
    }
  }

  return {
    undo,
    create
  };
};
